<template>
  <footer>
    <div class="container">
      <div class="copyright">
        Copyright © {{new Date().getFullYear()}} – Jwayelani
      </div>
      <a class="back-to-top" v-on:click="scrollTo('main-nav', 'back to top')">Back to Top <icon class="icon" name="chevron-up"></icon></a>
      <div class="clearfix"></div>
    </div>
  </footer>
</template>

<script>

import Vue from 'vue'

export default {
  name: 'j-footer',
  data () {
    return {}
  },
  methods: {
    scrollTo: function (id, gaLabel) {
      window.gtag('event', 'click', {
        'event_category': 'footer',
        'event_label': gaLabel
      })
      Vue.$scrollTo.go(id, null, 60)
      this.sideNavActive = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../scss/colours.scss';
  @import '../scss/mixins.scss';

  footer{
    background-color: $red-dark;
    color: white;

    .copyright{
      display: none;
      font-size: 0.9em;
      line-height: 80px;
      margin: 0;
      float: left;

      @include breakpoint(lg){
        display: block;
      }
    }

    .back-to-top{
      cursor: pointer;
      color: $yellow;
      font-size: 1.2em;
      line-height: 80px;
      display: block;
      float: right;

      .icon{
        margin-left: 5px;
        height: 20px;
        width: auto;
      }

      &:hover{
        color: white;
      }

      &:active{
        color: darken($yellow, 20%);
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue